import { FormSectionConfig } from '../Washroom/washroomJson';

const yesNoOptions = [
  {
    value: 'yes',
    text: 'Yes',
  },
  {
    value: 'no',
    text: 'No',
  },
];

export const kitchenConfig: FormSectionConfig[] = [
  // --------------------------------------------------
  // Kitchen taps
  // --------------------------------------------------
  {
    key: 'kitchen_tap_count',
    title: 'Tell us about the kitchen taps',
    icon: 'sink',

    counter: {
      min: 0,
      max: 30,
    },

    group: {
      titlePrefix: 'Kitchen tap',

      controls: [
        {
          key: 'kitchen_tap_type',
          type: 'dropdown',
          label: 'questions.question.28.text',
          options: [
            {
              value: '',
              label: 'questions.question.28.text',
            },
            {
              value: 'kitchen_tap_type_mixer_count',
              label: 'questions.mixer',
            },
            {
              value: 'kitchen_tap_type_pillar_count',
              label: 'questions.question.28.meta.73.74.text',
            },
            {
              value: 'kitchen_tap_type_other_count',
              label: 'Other',
            },
          ],
        },

        {
          key: 'kitchen_tap_flow_rate',
          type: 'dropdown',
          label: 'questions.question.29.text',

          // Flow rate depends on the selected kitchen tap type
          dependsOn: 'kitchen_tap_type',

          options: [
            {
              value: '',
              label: 'questions.question.29.text',
            },
            {
              value: 'kitchen_tap_flow_rate_weak_count',
              label: 'Weak <100 ml (Measure for 10 seconds)',
            },
            {
              value: 'kitchen_tap_flow_rate_medium_count',
              label: 'Medium 100-250 ml (Measure for 10 seconds)',
            },
            {
              value: 'kitchen_tap_flow_rate_strong_count',
              label: 'Strong >250 ml (Measure for 10 seconds)',
            },
          ],
        },

        {
          key: 'kitchen_tap_leak',
          type: 'dropdown',
          label: 'questions.question.31.text',
          options: [
            {
              value: '',
              label: 'questions.question.31.text',
            },
            {
              value: 'kitchen_dripping_slow_count',
              label: 'questions.question.31.meta.189.description',
            },
            {
              value: 'kitchen_dripping_moderately_count',
              label: 'questions.question.31.meta.190.description',
            },
            {
              value: 'kitchen_dripping_alot_count',
              label: 'questions.question.31.meta.191.description',
            },
            {
              value: null,
              label: 'No leak',
            },
          ],
        },
      ],

      copyFirstGroup: {
        enabled: false,
        options: yesNoOptions,
      },
    },
  },

  // --------------------------------------------------
  // Kitchen appliances
  // --------------------------------------------------
  {
    key: 'kitchen_appliances',
    title: 'Kitchen appliances',
    icon: 'kettle',

    controls: [
      {
        key: 'use_kettle',
        type: 'radio',
        label: 'questions.question.kettle',
        options: [
          {
            value: 'yes',
            label: 'Yes',
          },
          {
            value: 'no',
            label: 'No',
          },
        ],
      },

      {
        key: 'washing_up_method',
        type: 'dropdown',
        label: 'questions.question.46.text',
        options: [
          {
            value: '',
            label: 'questions.question.46.text',
          },
          {
            value: 'a-washing-up-bowl',
            label: 'questions.question.46.meta.139.139.text',
          },
          {
            value: 'the-kitchen-sink-with-a-plug',
            label: 'questions.question.46.meta.139.140.text',
          },
          {
            value: 'running-water-under-the-tap',
            label: 'questions.question.46.meta.139.141.text',
          },
        ],
      },

      {
        key: 'dishwasher_usage_per_week',
        type: 'counter',
        label: 'questions.question.47.text',
        min: 0,
        max: 30,
      },
    ],
  },
];
